import InputWrapper from '../Formik/InputWrapper'
import Label from '../Formik/Label'
import Input from '../Formik/Input'
import { useTranslation } from 'react-i18next'
import CheckBox from '../UI/CheckBox'
import RequiredLabelWrapper from '../UI/RequiredLabelWrapper'
import AllFieldsRequiredLabel from '../UI/AllFieldsRequiredLabel'

interface Props {
  formik: any
}

const PaymentUserDetailsForm = ({ formik }: Props) => {
  const { t } = useTranslation()
  const { errors, touched } = formik

  const showConsentsError =
    ('privacyPolicy' in errors && touched.privacyPolicy) ||
    ('termsAndConditions' in errors && touched.termsAndConditions) ||
    ('endUserLicenseAgreement' in errors && touched.endUserLicenseAgreement)

  return (
    <div className='flex flex-col'>
      <h2 className='text-[24px] font-bold'>{t('details')}</h2>
      <p className='text-lightGray mb-7'>{t('detailsDescription')}</p>
      <AllFieldsRequiredLabel />
      <div className='mt-4 grid sm:grid-cols-2 gap-5 sm:gap-10'>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('firstName')} />
          </RequiredLabelWrapper>
          <Input
            id='firstName'
            as='input'
            type='text'
            hasError={!!(formik.touched.firstName && formik.errors.firstName)}
            {...formik.getFieldProps('firstName')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('lastName')} />
          </RequiredLabelWrapper>
          <Input
            id='lastName'
            as='input'
            type='text'
            hasError={!!(formik.touched.lastName && formik.errors.lastName)}
            {...formik.getFieldProps('lastName')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('email')} />
          </RequiredLabelWrapper>
          <Input
            id='email'
            as='input'
            type='text'
            hasError={!!(formik.touched.email && formik.errors.email)}
            {...formik.getFieldProps('email')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('username')} />
          </RequiredLabelWrapper>
          <Input
            id='username'
            as='input'
            type='text'
            hasError={!!(formik.touched.username && formik.errors.username)}
            {...formik.getFieldProps('username')}
          />
        </InputWrapper>
      </div>
      <div className='flex flex-col gap-3 mt-10'>
        <div className='flex items-center gap-[10px]'>
          <CheckBox
            type='checkbox'
            {...formik.getFieldProps('termsAndConditions')}
            checked={formik.values.termsAndConditions}
            hasError={
              !!(
                formik.touched.termsAndConditions &&
                formik.errors.termsAndConditions
              )
            }
          />
          <p className='text-[#3E3E3E] text-[0.8125rem]'>
            {t('IhaveReadAndAgreeWithThe')}{' '}
            <a
              // TODO: Add terms and conditions link for production
              href='https://report-all-dev.konnekt-able.com/terms-and-conditions'
              target='_blank'
              rel='noreferrer'
              className='text-primaryBlue font-semibold'
            >
              {t('termsAndConditions')}
            </a>
            .
          </p>
        </div>
        <div className='flex items-start gap-[10px]'>
          <CheckBox
            type='checkbox'
            checked={formik.values.privacyPolicy}
            {...formik.getFieldProps('privacyPolicy')}
            hasError={
              !!(formik.touched.privacyPolicy && formik.errors.privacyPolicy)
            }
          />
          <p className='text-[#3E3E3E] text-[0.8125rem]'>
            {t('iHaveReadAndUnderstoodThe')}{' '}
            <a
              target='_blank'
              rel='noreferrer'
              href='https://report-all-dev.konnekt-able.com/privacy-policy'
              className='text-primaryBlue font-semibold'
            >
              {t('privacyPolicy')}
            </a>
            .
          </p>
        </div>
        <div className='flex items-start gap-[10px]'>
          <CheckBox
            type='checkbox'
            checked={formik.values.endUserLicenseAgreement}
            {...formik.getFieldProps('endUserLicenseAgreement')}
            hasError={
              !!(
                formik.touched.endUserLicenseAgreement &&
                formik.errors.endUserLicenseAgreement
              )
            }
          />
          <p className='text-[#3E3E3E] text-[0.8125rem]'>
            {t('iHaveReadAndUnderstoodThe')}{' '}
            <a
              target='_blank'
              rel='noreferrer'
              href='https://report-all-dev.konnekt-able.com/eula'
              className='text-primaryBlue font-semibold'
            >
              {t('endUserLicenseAgreement')}
            </a>
            .
          </p>
        </div>
      </div>
      {showConsentsError && (
        <p className='text-red-500 text-sm mt-3'>{t('allConsentsRequired')}</p>
      )}
    </div>
  )
}

export default PaymentUserDetailsForm
